var PageSvcs = (function ($) {

    PageSvcs = function (options) {
        var that = this;

        that.class = {
            sticky_observer: 'js-sticky-observer',
            is_stick       : 'is-stick',

            steps_wrapper: 'js-steps-wrapper',
            step         : 'js-step',
            screen_step  : 'js-screen-step',

            screen_target: 'js-screen-target',
            screen       : 'js-screen',

            total_amount   : 'js-total-amount',
            button_checkout: 'js-button-checkout',
            button_next    : 'js-button-next',
            button_submit  : 'js-button-submit',
            button_back    : 'js-back-button',

            step_current   : 'current',
            step_next_muted: 'next-muted'
        };

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$steps_wrapper = that.$wrapper.find('.' + that.class.steps_wrapper);
        that.$screen_steps = that.$steps_wrapper.find('.' + that.class.screen_step);
        that.$total_amount = that.$wrapper.find('.' + that.class.total_amount);
        that.$button_checkout = that.$wrapper.find('.' + that.class.button_checkout);
        that.$button_next = that.$wrapper.find('.' + that.class.button_next);
        that.$button_submit = that.$wrapper.find('.' + that.class.button_submit);
        that.$button_back = that.$wrapper.find('.' + that.class.button_back);

        // CONST
        that.order_hash = options['order_hash'];
        that.order_passenger_hash = options['order_passenger_hash'];
        that.order_currency = options['order_currency'] || '';
        that.templates = options['templates'];
        that.locales = options['locales'];
        that.urls = options['urls'];

        that.order_segments_ids = options['order_segments_ids'];
        that.order_passengers_ids = options['order_passengers_ids'];

        // DYNAMIC VARS
        that.current_screen_id = null;
        that.selected_svcs = [];
        that.submit_is_locked = false;
        that.order_total = options['order_total'] || 0;
        that.stop_next_step = false;

        // COMPONENTS
        that.screen_seats = null;
        that.screen_luggage = null;
        that.screen_meal = null;
        /** @type {SvcsScreenOther|null} */
        that.screen_other = null;
        that.screen_add = null;

        // ANALYTICS RELATED DATA
        /** @type {AnalyticsSvcsDataset} */
        that.analytics_dataset = options.analytics_dataset;

        // INIT
        that.init(options);

        $.sa.log(that);
    };

    PageSvcs.prototype.init = function (options) {
        var that = this;

        // clear storage BEFORE init screens - IMPORTANT
        that.initSvcsStorage();
        //
        that.initScreens(options['screens']);
        //
        that.initSteps(options['screen_current']);
        //
        that.displayTotalAmount();
        //
        that.stickObserve();
        //
        that.initPaymentStepButton();
        //
        that.initButtonNext();
        //
        that.initButtonSubmit();
        //
        that.initOrderWillBeCanceledModal();
        // 
        that.handlerLoader();
    };

    PageSvcs.prototype.initScreens = function (screens_options) {
        var that = this;

        // Selected svcs data from other components:
        // - (int)    passenger_id: equals to `order_passenger_id`,
        // - (int)    segment_id: equals to `order_segment_id`,
        // - (int)    item_id: equals to `airline_svc_id`
        // - (string) item_text: text data of selected item
        // - (float)  item_price: selected item price,
        // - (int)    item_quantity,

        // Seats screen
        if (screens_options.hasOwnProperty('seats')) {
            that.screen_seats = new SvcsScreenSeats(Object.assign({}, screens_options['seats'], {
                order_currency      : that.order_currency,
                analytics_dataset   : that.analytics_dataset,
                order_segments_ids  : that.order_segments_ids,
                order_passengers_ids: that.order_passengers_ids,

                onPassengerSelected: function (data, component) {
                    that.__onSvcsSelected(data);
                },
                onPassengerReset: function (data, component) {
                    that.__onSvcsReset(data);
                },
                onSeatsIncompleteWarningCancelClosed: function (next_screen_id) {
                    that.stop_next_step = false;
                    that.__setScreen(next_screen_id, true, false);
                },
                onSeatsEmptyWarningCancelClosed: function (next_screen_id) {
                    that.stop_next_step = false;
                    that.__setScreen(next_screen_id, true, false);
                }
            }));
        }

        // Luggage screen
        if (screens_options.hasOwnProperty('luggage')) {
            that.screen_luggage = new SvcsScreenLuggage(Object.assign({}, screens_options['luggage'], {
                order_currency      : that.order_currency,
                analytics_dataset   : that.analytics_dataset,
                order_segments_ids  : that.order_segments_ids,
                order_passengers_ids: that.order_passengers_ids,

                onPassengerSelected: function (data, component) {
                    that.__onSvcsSelected(data);
                },
                onPassengerReset: function (data, component) {
                    that.__onSvcsReset(data);
                },
                onLuggageIncompleteWarningCancelClosed: function (next_screen_id) {
                    that.stop_next_step = false;
                    that.__setScreen(next_screen_id, true, false);
                },
                onLuggageAdditionalEmptyWarningCancelClosed: function (next_screen_id) {
                    that.stop_next_step = false;
                    that.__setScreen(next_screen_id, true, false);
                }
            }));
        }

        // Meal screen
        if (screens_options.hasOwnProperty('meal')) {
            const $meal_wrapper = screens_options.meal.$wrapper;
            if ($meal_wrapper && $meal_wrapper.length) {
                that.screen_meal = new SvcsScreenMeal($meal_wrapper, Object.assign({}, screens_options['meal'], {
                    order_currency      : that.order_currency,
                    analytics_dataset   : that.analytics_dataset,
                    order_segments_ids  : that.order_segments_ids,
                    order_passengers_ids: that.order_passengers_ids,

                    onSvcSelected: function (data, component) {
                        if (Array.isArray(data)) {
                            data.forEach(function (data_item) {
                                that.__onSvcsSelected(data_item);
                            });
                        } else {
                            that.__onSvcsSelected(data);
                        }
                    },
                    onSvcReset: function (data, component) {
                        if (Array.isArray(data)) {
                            data.forEach(function (data_item) {
                                that.__onSvcsReset(data_item);
                            });
                        } else {
                            that.__onSvcsReset(data);
                        }
                    }
                }));
            }
        }

        // Other screen
        if (screens_options.hasOwnProperty('other')) {
            that.screen_other = new SvcsScreenOther(Object.assign({}, screens_options['other'], {
                order_currency      : that.order_currency,
                analytics_dataset   : that.analytics_dataset,
                order_segments_ids  : that.order_segments_ids,
                order_passengers_ids: that.order_passengers_ids,

                onSvcSelected: function (data, component) {
                    if (Array.isArray(data)) {
                        data.forEach(function (data_item) {
                            that.__onSvcsSelected(data_item);
                        });
                    } else {
                        that.__onSvcsSelected(data);
                    }
                },
                onSvcReset: function (data, component) {
                    if (Array.isArray(data)) {
                        data.forEach(function (data_item) {
                            that.__onSvcsReset(data_item);
                        });
                    } else {
                        that.__onSvcsReset(data);
                    }
                },
                onInsuranceEmptyWarningClose: function (step, next_screen_id) {
                    if (!!next_screen_id) {
                        that.stop_next_step = false;
                        that.__setScreen(next_screen_id, false, false);
                    } else {
                        that.submit(that.$button_next, true);
                    }
                }
            }));
        }

        // Add screen
        if (screens_options.hasOwnProperty('add')) {
            that.screen_add = new PageSvcsAdd(Object.assign({}, screens_options['add'], {
                order_currency      : that.order_currency,
                order_segments_ids  : that.order_segments_ids,
                order_passengers_ids: that.order_passengers_ids,
                analytics_dataset   : that.analytics_dataset,
                onSvcSelected       : function (data, component) {
                    if (Array.isArray(data)) {
                        data.forEach(function (data_item) {
                            that.__onSvcsSelected(data_item);
                        });
                    } else {
                        that.__onSvcsSelected(data);
                    }
                },
                onSvcReset: function (data, component) {
                    if (Array.isArray(data)) {
                        data.forEach(function (data_item) {
                            that.__onSvcsReset(data_item);
                        });
                    } else {
                        that.__onSvcsReset(data);
                    }
                }
            }));
        }
    };

    PageSvcs.prototype.__onSvcsSelected = function (data) {
        var that = this,
            item_quantity_new = data['item_quantity'] ? parseInt(data['item_quantity'], 10) : 0,
            item_quantity_diff = data['item_quantity_diff'] ? parseInt(data['item_quantity_diff'], 10) : 0;

        // if quantity=0 - remove svc
        if (item_quantity_new === 0) {
            that.removeSvc(data);
        } else {
            that.saveSvc(data);
        }

        // if quantity was changed - calculate new total amount and display it
        if (item_quantity_diff !== 0) {
            if (data.hasOwnProperty('item_price')) {
                that.changeTotalAmount(data.item_price, item_quantity_diff);
                that.displayTotalAmount();
            } else {
                $.sa.log('Could not count total price: missing data');
            }
        }
    };

    PageSvcs.prototype.__onSvcsReset = function (data) {
        var that = this;

        if (that.hasSvc(data) !== false) {
            var item_price = data['item_price'] ? parseFloat(data['item_price']) : 0,
                item_quantity_diff = data['item_quantity_diff'] ? parseInt(data['item_quantity_diff'], 10) : 0;

            that.removeSvc(data);

            if (data.hasOwnProperty('item_price')) {
                that.changeTotalAmount(item_price, item_quantity_diff);
                that.displayTotalAmount();
            } else {
                $.sa.log('Could not count total price: missing data');
            }
        }
    };

    PageSvcs.prototype.initSteps = function (initial_screen_id) {
        var that = this;

        that.__setScreen(initial_screen_id);

        that.$wrapper.on('click', '.' + that.class.screen_target, function () {
            var $screen_target = $(this);
            that.__setScreen($screen_target.data('id'));
        });
    }

    /**
     * @param {String} screen_id Ключ из объекта screens переданного из svcs.html ('seats', 'luggage' e t.c.)
     * @param {Boolean} scroll Скролл к началу навигации
     * @param {Boolean} warning_enabled включает проверку warning modal
     * @return {boolean}
     * @private
     */
    PageSvcs.prototype.__setScreen = function (screen_id, scroll = false, warning_enabled = true) {
        var that = this;

        if (warning_enabled) {
            that.__initSvcsWarnings(that.current_screen_id, screen_id);
        }

        if (that.current_screen_id === screen_id || that.stop_next_step) {
            return false;
        }
        that.current_screen_id = screen_id;

        that.$screen_steps
            .removeClass(that.class.step_current)
            .removeClass(that.class.step_next_muted);

        that.$steps_wrapper.find('.' + that.class.screen_step + '[data-id="' + that.current_screen_id + '"]')
            .addClass(that.class.step_current)
            .addClass(that.class.step_next_muted);

        that.$wrapper.find('.' + that.class.screen).hide();
        that.$wrapper.find('.' + that.class.screen + '[data-id="' + that.current_screen_id + '"]')
            .show()
            .promise()
            .done(() => {
                if (typeof that[`screen_${that.current_screen_id}`].onShow === "function") {
                    that[`screen_${that.current_screen_id}`].onShow();
                }
            });

        if (scroll) {
            $.sa.scrollToNode(that.$steps_wrapper, 300);
        }
    };

    PageSvcs.prototype.__getNextStep = function () {
        var that = this,
            $current_step = that.__getCurrentStep();
        return $current_step.next();
    };

    PageSvcs.prototype.__getLastStep = function () {
        var that = this;
        return that.$screen_steps.last();
    };

    PageSvcs.prototype.__getCurrentStep = function () {
        var that = this;
        return that.$screen_steps.filter('.' + that.class.step_current);
    };

    PageSvcs.prototype.__getScreenIdByStep = function ($step) {
        return $step.data('id');
    };

    PageSvcs.prototype.initSvcsStorage = function () {
        var that = this;

        // clear svcs storage
        that.clearSvc();
    };

    PageSvcs.prototype.saveSvc = function (data) {
        var that = this,
            svcs_item_exists = false,
            item_quantity_new = data['item_quantity'] || 0;

        // search for that svc
        if (
            data['item_id'] &&
            data['passenger_id'] &&
            data['segment_id']
        ) {
            // if svc is already saved - update its dynamic properties (for now it's only `quantity`)
            that.selected_svcs.forEach(function (svcs_item, index) {
                if (that.__isTheSameSvc(svcs_item, data)) {
                    // just in case, if there is multiple items with this data in that.selected_svcs:
                    // if one item was already found, set quantity as 0 for other ones
                    that.selected_svcs[index]['item_quantity'] = !svcs_item_exists ? item_quantity_new : 0;
                    svcs_item_exists = true;
                }
            });
        }

        if (!svcs_item_exists) {
            that.selected_svcs.push({ // filter data to prevent sending extra data to server
                item_id      : data['item_id'],
                passenger_id : data['passenger_id'],
                segment_id   : data['segment_id'],
                item_quantity: data['item_quantity'],
                item_text    : data['item_text'] || ''
            });
        }
    };

    PageSvcs.prototype.removeSvc = function (data) {
        if (
            !data['item_id'] ||
            !data['passenger_id'] ||
            !data['segment_id']
        ) {
            return;
        }

        var that = this,
            svcs_new;

        if (!that.selected_svcs || !that.selected_svcs.length) {
            return;
        }

        svcs_new = that.selected_svcs.filter(function (svcs_item) {
            return !that.__isTheSameSvc(svcs_item, data);
        });

        that.selected_svcs = svcs_new;
    };

    // returns svc's index, if found, otherwise returns false
    PageSvcs.prototype.hasSvc = function (data) {
        var that = this;

        if (!that.selected_svcs || !that.selected_svcs.length) {
            return false;
        }

        return that.selected_svcs.some(svc => that.__isTheSameSvc(svc, data));
    };

    PageSvcs.prototype.__isTheSameSvc = function (svc, data) {
        return (
            svc['item_id'].toString() === data['item_id'].toString() &&
            svc['passenger_id'].toString() === data['passenger_id'].toString() &&
            svc['segment_id'].toString() === data['segment_id'].toString() &&
            ((svc['item_text'] === data['item_text']) || !data['item_text'])
        );
    };

    PageSvcs.prototype.clearSvc = function () {
        var that = this;
        that.selected_svcs = [];
    };

    PageSvcs.prototype.handlerLoader = function () {
        var that = this;

        $.sa.$document.one('avia_before_load', function() {
            that.__submitButtonLock(that.$button_submit, true, false);
            that.__submitButtonLock(that.$button_next, true, false);
            that.__backButtonLock(true);
        });

        $.sa.$document.one('avia_after_load', function() {
            that.__submitButtonLock(that.$button_submit, false, false);
            that.__submitButtonLock(that.$button_next, false, false);
            that.__backButtonLock(false);
        });
    };

    PageSvcs.prototype.__backButtonLock = function (state) {
        var that = this;

        if (!that.$button_back.length) {
            return;
        }

        if (state === true) {
            that.$button_back.addClass('events-none');
        } else {
            that.$button_back.removeClass('events-none');
        }
    };

    PageSvcs.prototype.__submitButtonLock = function ($button, state, loading = true) {
        var that = this;

        if (loading) {
            $.sa.buttonLoading($button, state);
        }
        $button.prop('disabled', state);
    };

    PageSvcs.prototype.submit = function ($button, force_submit = null) {
        var that = this;

        if (that.submit_is_locked) {
            return false;
        } else if (force_submit) {
            return that.__runSubmit($button);
        } else if (!validate()) {
            return false;
        }

        /**
         * Ниже идёт цепочка promise-событий для удобства отслеживания
         * Resolve - вариант означает остановку сабмита и какие-то реакции в стиле показать модалку и т.д.
         * Reject  - вариант ведет к сабмиту
         * */

        const is_add_screen = (that.screen_add !== null);
        if (is_add_screen) {
            isEmptySvcs()
                .then( function() {
                    // if at Add flow not selected any services
                    $.uiModal({
                        mobile_fullscreen: false,
                        $wrapper: $(that.screen_add.modals['not_selected_svcs']).clone(),
                        disable_content_scroll: true,
                    });
                })
                .catch( function() {
                    that.__runSubmit($button);
                });

        } else {
            // Проверяем есть ли добавленные услуги
            isEmptySvcs()
                // Если их нет, то проверяем наличие промокода
                .then( function() {
                    lock(true);
                    return that.getPromocode();
                })
                // Если промокода нет, то проверяем страховку
                .catch( function() {
                    lock(false);
                    const show_empty_insurance_modal = (that.screen_other ? that.screen_other.isRenderedInsuranceEmptyWarningOn('submit') : false);
                    return Promise.reject({
                        stop: show_empty_insurance_modal
                    });
                })
                // Если промокод есть, то показываем модалку
                .then( function(promocode) {
                    lock(false);
                    return that.showSvcsPromocodeModal(promocode);
                })
                // Если пользователь нажал кнопку "добавить услуги" переводим на первый экран
                .then( function(action) {
                    if (action === 'svsc') {
                        that.__setScreen('seats', false, false);
                    }
                })
                // Если на одном из этапов пользователь вышел из цепочки действий - делаем запрос
                .catch( function(options = {}) {
                    const run_submit = !options.stop;
                    if (run_submit) {
                        that.__runSubmit($button);
                    }
                });
        }

        /**
         * @param {Boolean?} lock
         * */
        function lock(lock = true) {
            that.__submitButtonLock($button, lock);
            that.__backButtonLock(lock);
            that.submit_is_locked = lock;
        }

        /**
         * @returns {Promise}
         * */
        function isEmptySvcs() {
            return new Promise( function(resolve, reject) {
                if (!that.selected_svcs.length) {
                    resolve();
                } else {
                    reject();
                }
            });
        }

        function validate() {
            let result = true;

            if (that.current_screen_id === 'other') {
                // Валидация блока страховки
                if (!that.screen_other.validate()) {
                    result = false;
                }
            }

            return result;
        };
    }

    PageSvcs.prototype.__runSubmit = function($button) {
        var that = this;

        if (that.submit_is_locked) {
            return false;
        }

        that.submit_is_locked = true;

        var order_href = that.order_passenger_hash ?
                $.sa.build_url('order/' + that.order_hash + '-' + that.order_passenger_hash) :
                $.sa.build_url('order/' + that.order_hash),
            order_svcs_add_href = order_href + '/svcs/add',
            order_checkout_href = order_href + '/checkout',
            data = {svcs: that.selected_svcs},
            finish_loading = false;

        that.__submitButtonLock($button, true);
        that.__backButtonLock(true);

        $.post(order_svcs_add_href, data, function (res) {
            if (res && res.status === 'ok' && res.data === true) {
                $.sa.content_router.load(order_checkout_href);
            } else if (res.errors) {
                var error = res.errors[0];

                if (
                    // Number of ssr seat's on the passenger/segment is more than passenger number seats
                    error['code'] === 42101 ||
                    // Number of services mismatch with ssr seat
                    error['code'] === 42102
                ) {
                    $.uiModal({
                        header_icons        : '<i class="fab fa-sa-fill-circle-x"></i>',
                        header_title        : that.locales['seats']['error_seats_unavailable']['title'],
                        content             : that.locales['seats']['error_seats_unavailable']['description'],
                        button_confirm_text : that.locales['seats']['error_seats_unavailable']['button_submit_text'],
                        button_cancel_text  : that.locales['seats']['error_seats_unavailable']['button_cancel_text'],
                        onButtonCancelClick : function (modal, event) {
                            resetSeats();
                            // repeat submit
                            that.submit($button);
                        },
                        onButtonConfirmClick: function (modal, event) {
                            resetSeats();
                            // set Seats screen active
                            that.__setScreen('seats');
                        }
                        // Do not refresh page on close, because we should not drop other selected svcs
                    });
                    // unset loading state from button
                    that.__submitButtonLock($button, false);
                    that.__backButtonLock(false);
                    finish_loading = true;
                } else if (
                    // Already have same svc in PNR
                    error['code'] === 42002
                ) {
                    $.uiModal({
                        header_icons             : '<i class="fab fa-sa-fill-circle-x"></i>',
                        header_title             : that.locales['errors'][error['code']]['title'],
                        content                  : that.locales['errors'][error['code']]['content'],
                        button_cancel_text       : that.locales['errors'][error['code']]['button_cancel_text'],
                        close_on_avia_before_load: false, // without it "too much recursion" error been triggered
                        onClose                  : function () {
                            $.sa.content_router.reload();
                        }
                    });
                } else {
                    $.uiModal({
                        header_icons      : '<i class="fab fa-sa-fill-circle-x"></i>',
                        header_title      : $.sa.locales['error'] + ' ' + error['code'],
                        content           : error['message'],
                        button_cancel_text: $.sa.locales['close'],
                        onClose           : function () {
                            window.location.reload();
                        }
                    });
                }
                $.sa.log(res.errors);
            } else {
                $.uiModal({
                    header_icons      : '<i class="fab fa-sa-fill-circle-x"></i>',
                    header_title      : $.sa.locales['error'],
                    content           : $.sa.locales['something_went_wrong'],
                    button_cancel_text: $.sa.locales['close']
                });

                that.__submitButtonLock($button, false);
                that.__backButtonLock(false);
                finish_loading = true;

                $.sa.log(res);
            }
        }).fail(function (jqXHR) {
            $.uiModal({
                header_icons      : '<i class="fab fa-sa-fill-circle-x"></i>',
                header_title      : $.sa.locales['error'] + ' ' + jqXHR.status,
                content           : jqXHR.responseText,
                button_cancel_text: $.sa.locales['close']
            });

            that.__submitButtonLock($button, false);
            that.__backButtonLock(false);
            finish_loading = true;

            $.sa.log(jqXHR.responseText);
        }).always(function () {
            that.submit_is_locked = false;
            // TODO(d.elshin): Gotta fix this. Eg., can listen to the event,
            //  which send content_router, when the page was loaded (like there is).
            //  But also need to be careful. There may be a case when some (!)other page loaded.
            setTimeout(function () {
                if (!finish_loading) {
                    that.__submitButtonLock($button, true);
                    that.__backButtonLock(true);
                }
            }, 5000);
            return false;
        });

        function resetSeats() {
            // Main Flow
            if (null !== that.screen_seats) {
                that.screen_seats.select_segment_passengers.forEach(function (select_segment_passengers) {
                    select_segment_passengers.resetSegment();
                });
            }
            // Add Flow
            else if (null !== that.screen_add) {
                that.screen_add.resetSvcsUnpaid('seat_assignment');
            }
        }
    };

    PageSvcs.prototype.stickObserve = function () {
        var that = this,
            $observer = that.$wrapper.find('.' + that.class.sticky_observer);

        $observer.each(function () {
            $.sa.stickyObserver(this, that.class.is_stick);
        });
    };

    PageSvcs.prototype.initPaymentStepButton = function () {
        var that = this;

        that.$button_checkout.on('click', function (e) {
            e.preventDefault;
            that.submit(that.$button_next || that.$button_submit);
        });
    }

    PageSvcs.prototype.initButtonNext = function () {
        var that = this;

        that.$button_next.on('click', function (e) {
            var $current_step = that.__getCurrentStep(),
                $last_step = that.__getLastStep();

            if (!$current_step.is($last_step)) {
                var $next_step = that.__getNextStep(),
                    next_step_id = that.__getScreenIdByStep($next_step);

                that.__setScreen(next_step_id, true);
            }
            // submit on last step
            else {
                that.submit(that.$button_next);
            }
        });
    };

    PageSvcs.prototype.initButtonSubmit = function () {
        var that = this;

        that.$button_submit.on('click', function (e) {
            that.submit(that.$button_submit);
        });
    };

    PageSvcs.prototype.changeTotalAmount = function (value, multiplier = 1) {
        value = parseFloat(value);
        multiplier = parseFloat(multiplier);

        var that = this,
            amount = value * multiplier;

        if (amount < 0 && that.order_total < Math.abs(amount)) {
            $.sa.log('Error count total price');
        } else {
            that.order_total += value * multiplier;
        }
    };

    PageSvcs.prototype.displayTotalAmount = function () {
        var that = this;

        if (!that.order_currency) {
            return;
        }

        that.$total_amount.text($.sa.format.price(that.order_total, that.order_currency));
    };

    PageSvcs.prototype.initOrderWillBeCanceledModal = function () {
        var that = this;

        that.$wrapper.on('click', '.js-order-will-be-canceled', function (event) {
            event.preventDefault();

            var $link = $(this),
                href = $link.attr('href');

            $.sa.confirm.show({
                class_header: 'align-center',
                class_content: 'align-center',
                class_buttons: 'flex-center',
                icons: that.locales['order']['cancel']['icons'],
                title: that.locales['order']['cancel']['title'],
                content: that.locales['order']['cancel']['content'],
                onConfirm: function () {
                    $.post(that.urls['booking_cancel'], {order_hash: that.order_hash});
                    $.sa.content_router.load(href);
                }
            });
        });
    };

    PageSvcs.prototype.__initSvcsWarnings = function (screen_id, next_screen_id) {
        var that = this;

        that.stop_next_step = false;

        if (!screen_id || !next_screen_id) {
            return;
        }

        if (that.screen_seats.isRenderedSeatsIncompleteWarning(screen_id, next_screen_id)) {
            that.stop_next_step = true;
        }

        if (that.screen_seats.isRenderedSeatsEmptyWarning(screen_id, next_screen_id, that.order_passengers_ids.length, that.order_segments_ids.length)) {
            that.stop_next_step = true;
        }

        if (that.screen_luggage.isRenderedLuggageIncompleteWarning(screen_id, next_screen_id)) {
            that.stop_next_step = true;
        }

        if (that.screen_luggage.isRenderedLuggageAdditionalEmptyWarning(screen_id, next_screen_id)) {
            that.stop_next_step = true;
        }

        // Если мы находимся в разделе "Питание", то останавливаем переход если раздел невалидный
        if (that.screen_meal && screen_id === 'meal') {
            const is_valid = that.screen_meal.isValid();
            if (!is_valid) {
                that.stop_next_step = true;

                // Promise
                that.screen_meal.showWarningModal()
                    .then( function() {
                        that.__setScreen(next_screen_id, true);
                    })
                    .catch( function() {});
            }
        }

        if (that.screen_other) {
            let is_screen_valid = true;

            if (screen_id === 'other') {
                const is_valid = that.screen_other.validate();
                if (!is_valid) {
                    is_screen_valid = false;
                    that.stop_next_step = true;
                }
            }

            if (is_screen_valid && that.screen_other.isRenderedInsuranceEmptyWarningOn(screen_id, next_screen_id)) {
                is_screen_valid = false;
                that.stop_next_step = true;
            }
        }
    };

    PageSvcs.prototype.svcsSelectedCleanSort = function (items) {
        var that = this,
            svcs_items = [];

        // remove items with item_quantity < 0
        items.forEach(function (el) {
            if (parseInt(el.item_quantity, 10) > 0) {
                svcs_items.push(el);
            }
        });

        // sort items by passenger_id
        svcs_items.sort(function (item1, item2){
            if (parseInt(item1.passenger_id, 10) < parseInt(item2.passenger_id, 10)) {
                return -1;
            }
            if (parseInt(item1.passenger_id, 10) > parseInt(item2.passenger_id, 10)) {
                return 1;
            }
            return 0;
        });

        return svcs_items;
    };

    /**
     * @returns {Promise<Object>}
     * */
    PageSvcs.prototype.getPromocode = async function() {
        var that = this;

        // Использую текущую функцию как объект для хранения/кеширования промежуточных данных запроса
        const storage = PageSvcs.prototype.getPromocode;
        if (storage.promise) { return storage.promise; }

        storage.promise = new Promise( function(resolve, reject) {
            $.post(that.urls['promocode'], 'json')
                .always( function() {
                    storage.promise = null;
                })
                .fail( function() {
                    reject();
                })
                .done( function(response) {
                    if (response.status === "ok") {
                        if (response.data && response.data.promocode) {
                            resolve(response.data.promocode);
                        } else {
                            reject();
                        }
                    } else {
                        reject(response.error);
                    }
                });
        });

        return storage.promise;
    };

    /**
     * @param {Object} promocode
     * @returns {jQuery<Promise>}
     * */
    PageSvcs.prototype.showSvcsPromocodeModal = function(promocode) {
        const that = this;

        const deferred = $.Deferred();

        let redirect = null;

        $.uiModal({
            html: getHTML(promocode),
            onOpen: initModal,
            onButtonCancelClick: function() {
                deferred.reject();
            },
            onButtonConfirmClick: function() {
                redirect = 'svsc';
            },
            onClose: function() {
                deferred.resolve(redirect);
            }
        });

        return deferred.promise();

        function initModal($modal, modal) {
            $modal.on('click', '.js-copy-promocode', function() {
                if (promocode.code) {
                    $.sa.copyToBuffer(promocode.code);
                    $.sa.notifier.show({
                        title: that.locales['promocode']['copied'],
                        notifier_class: $.sa.notifier.class.success
                    });
                } else {
                    $.sa.notifier.show({
                        title: that.locales['promocode']['error'],
                        notifier_class: $.sa.notifier.class.error
                    });
                }
            });
        }

        /**
         * @param {Object} promocode
         * */
        function getHTML(promocode) {
            let discount_value = promocode.discount_value;
            if (promocode.discount_unit === 'percent') {
                discount_value = parseFloat(promocode.discount_value) + "%";
            }

            return that.templates['promocode_modal']
                .replace(/{ { code } }/g, promocode.code)
                .replace(/{ { discount_value } }/g, discount_value);
        }
    };

    return PageSvcs;
})($);